import React, { useState } from "react";
import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import EditModule from "../../../components/content/EditModule/EditModule";
import { useUpdateContentModuleNameMutation, GetGeneratedContentDocument } from "../../../graphql/generated/graphql";

const EditModuleNameModalContainer = ({ visible, onClose, onDelete, moduleName, courseId }) => {
  const { isMedium } = useResponsiveScreen();
  const [newModuleName, setNewModuleName] = useState("");
  const [updateModuleName, { loading }] = useUpdateContentModuleNameMutation({
    refetchQueries: [
      {
        query: GetGeneratedContentDocument,
      },
    ],
  });

  const handleUpdateModuleName = async () => {
    try {
      const response = await updateModuleName({
        variables: {
          courseId,
          oldModuleName: moduleName,
          newModuleName,
        },
      });

      if (response?.data?.updateContentModuleName?.success) {
        console.log("Module name updated successfully!");
        onClose();
      } else {
        console.error("Failed to update module name:", response?.data?.updateContentModuleName?.message);
      }
    } catch (e) {
      console.error("Error updating module name:", e);
    }
  };

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      title="Edit Module Name"
      style={{ width: isMedium ? "50%" : "90%" }}>
      <EditModule
        onChangeName={setNewModuleName}
        moduleName={moduleName}
        deleteButtonClick={onDelete}
        backButtonClick={onClose}
        saveButtonClick={handleUpdateModuleName}
        isLoading={loading}
      />
    </CustomModal>
  );
};

export default EditModuleNameModalContainer;
